module.exports = __webpack_public_path__ + "static/NB-f13d7dc50b39b786bc333c78b0bbe4f1.woff";